/* DealsHub Cart v3.0 — Amazon-Style Selection + Delete + Save for Later
   Features:
   - Groups cart items by source store
   - Shows shipping cost per store group (from /api/shipping)
   - Threshold hints (e.g., "Add $X more for FREE shipping")
   - StyleHub Plus: FREE shipping when member, upsell when not
   - Quantity controls
   - Trash icon delete per item
   - Checkboxes per item (Amazon-style selection)
   - Select All / Deselect All
   - Save for Later
   - Mobile responsive
*/
(function(){
  'use strict';

  // Inject tooltip styles
  (function(){
    var s=document.createElement('style');
    s.textContent='.dh-tax-tip{position:relative;display:inline-block;vertical-align:middle;margin-left:3px;cursor:pointer}'+
      '.dh-tax-tip .dh-tip-icon{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:50%;background:#e2e8f0;color:#718096;font-size:10px;font-style:normal;font-weight:600;line-height:1}'+
      '.dh-tax-tip .dh-tip-box{display:none;position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);width:220px;padding:10px 12px;background:#1a202c;color:#fff;font-size:12px;line-height:1.4;border-radius:8px;z-index:100;text-align:left;font-weight:400;box-shadow:0 4px 12px rgba(0,0,0,.15)}'+
      '.dh-tax-tip .dh-tip-box::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:6px solid transparent;border-top-color:#1a202c}'+
      '.dh-tax-tip.active .dh-tip-box{display:block}';
    document.head.appendChild(s);
    document.addEventListener('click',function(e){
      if(!e.target.closest('.dh-tax-tip')){
        document.querySelectorAll('.dh-tax-tip.active').forEach(function(t){t.classList.remove('active')});
      }
    });
  })();
  var API='https://dealshub-search.onrender.com';
  var container=document.getElementById('dealshub-cart');
  if(!container)return;

  var cartData=null;
  var shippingByStore={};
  var zip=localStorage.getItem('stylehub_zip')||'';
  var isPlus=localStorage.getItem('stylehub_plus')==='true';
  var selectedItems={};    // key -> true/false
  var savedForLater=JSON.parse(localStorage.getItem('stylehub_saved_later')||'[]');

  init();

  function init(){
    container.innerHTML=cartSkeleton();
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json()})
      .then(function(data){
        cartData=data;
        if(!data.items||data.items.length===0){
          renderEmpty();
          return;
        }
        // Initialize all items as selected if not already set
        data.items.forEach(function(item){
          if(selectedItems[item.key]===undefined) selectedItems[item.key]=true;
        });
        // Clean up selectedItems for items no longer in cart
        Object.keys(selectedItems).forEach(function(k){
          if(!data.items.find(function(i){return i.key===k})) delete selectedItems[k];
        });
        renderCart(data);
        fetchShippingForStores(data.items);
      })
      .catch(function(err){
        console.error('Cart fetch error:',err);
        container.innerHTML='<div style="text-align:center;padding:60px 20px"><h2>Unable to load cart</h2><p>Please try refreshing the page.</p></div>';
      });
  }

  function getSource(item){
    var props=item.properties||{};
    if(!item.requires_shipping&&item.product_type==='subscription') return '_subscription';
    return props._source||props._source_store||'unknown';
  }

  function getSourceId(item){
    var props=item.properties||{};
    return props._source_id||'';
  }

  function groupByStore(items){
    var groups={};
    items.forEach(function(item){
      var src=getSource(item);
      if(!groups[src])groups[src]=[];
      groups[src].push(item);
    });
    return groups;
  }

  function storeLabel(src){
    var map={amazon:'\uD83C\uDDFA\uD83C\uDDF8 USA Fulfillment',aliexpress:'\uD83D\uDCE6 Multi-Origin',shein:'StyleHub',macys:'StyleHub',sephora:'StyleHub',_subscription:'Subscriptions',unknown:'StyleHub'};
    return map[src]||'StyleHub';
  }

  function fetchShippingForStores(items){
    var groups=groupByStore(items);
    var stores=Object.keys(groups);
    stores.forEach(function(src){
      if(src==='_subscription'){
        shippingByStore[src]={shipping:{cost:0,isFree:true,isDigital:true,label:'No shipping required'},delivery:{label:'Digital product'}};
      }
    });
    stores=stores.filter(function(src){return src!=='_subscription'});
    var promises=stores.map(function(src){
      var storeTotal=groups[src].reduce(function(sum,item){
        return sum+(item.price/100)*item.quantity;
      },0);
      var firstItem=groups[src][0];
      var productId=getSourceId(firstItem)||'';
      var url=API+'/api/shipping?store='+encodeURIComponent(src)+'&price='+storeTotal.toFixed(2)+'&mode=rules';
      if(productId)url+='&productId='+encodeURIComponent(productId);
      if(zip)url+='&zip='+encodeURIComponent(zip);
      if(isPlus)url+='&plus=true';
      return fetch(url,{signal:AbortSignal.timeout(15000)})
        .then(function(r){return r.json()})
        .then(function(d){if(!d.error)shippingByStore[src]=d;else shippingByStore[src]=null;})
        .catch(function(){shippingByStore[src]=null;});
    });
    Promise.all(promises).then(function(){updateShippingUI();});
  }

  function renderEmpty(){
    var html='<div class="dh-cart-empty">'+
      '<div class="dh-cart-empty-icon">\uD83D\uDED2</div>'+
      '<h2>Your cart is empty</h2>'+
      '<p>Looks like you haven\'t added anything to your cart yet.</p>'+
      '<a href="/" class="dh-cart-continue">Continue Shopping</a>'+
    '</div>';
    // Show saved for later even when cart is empty
    if(savedForLater.length>0){
      html+=renderSavedForLater();
    }
    container.innerHTML=html;
  }

  /* ── Selection helpers ─────────────────── */
  function allSelected(){
    if(!cartData||!cartData.items||cartData.items.length===0)return false;
    return cartData.items.every(function(item){return selectedItems[item.key]===true;});
  }

  function noneSelected(){
    if(!cartData||!cartData.items)return true;
    return cartData.items.every(function(item){return !selectedItems[item.key]});
  }

  function getSelectedCount(){
    if(!cartData||!cartData.items)return 0;
    return cartData.items.filter(function(item){return selectedItems[item.key]===true}).length;
  }

  function getSelectedSubtotal(){
    if(!cartData||!cartData.items)return 0;
    return cartData.items.reduce(function(sum,item){
      if(selectedItems[item.key])return sum+(item.price*item.quantity);
      return sum;
    },0);
  }

  /* ── Main render ─────────────────── */
  function renderCart(data){
    var groups=groupByStore(data.items);
    var storeKeys=Object.keys(groups);
    var totalItems=data.item_count;
    var selCount=getSelectedCount();

    var html='<div class="dh-cart-header">'+
      '<h1>Shopping Cart <span class="dh-cart-header-count">('+totalItems+' item'+(totalItems!==1?'s':'')+')</span></h1>';
    // ZIP location bar
    html+='<div class="dh-cart-location" id="dh-cart-location">';
    if(zip){
      html+='<span>\uD83D\uDCCD Delivering to <strong>'+escHTML(zip)+'</strong></span> <a href="#" onclick="document.getElementById(\'dh-cart-zip-input\').style.display=\'inline-flex\';this.style.display=\'none\';return false" class="dh-cart-change-zip">Change</a>';
      html+='<span id="dh-cart-zip-input" style="display:none;margin-left:8px"><input type="text" id="dh-cart-zip-field" placeholder="ZIP code" maxlength="5" value="'+escHTML(zip)+'" style="width:80px;padding:4px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px"> <button onclick="saveZip()" style="padding:4px 10px;background:#2d3748;color:#fff;border:none;border-radius:4px;font-size:12px;cursor:pointer">Update</button></span>';
    } else {
      html+='<span>\uD83D\uDCCD Enter your ZIP for shipping estimates</span> ';
      html+='<input type="text" id="dh-cart-zip-field" placeholder="ZIP code" maxlength="5" style="width:80px;padding:4px 8px;border:1px solid #ddd;border-radius:4px;font-size:13px"> <button onclick="saveZip()" style="padding:4px 10px;background:#2d3748;color:#fff;border:none;border-radius:4px;font-size:12px;cursor:pointer">Check</button>';
    }
    html+='</div></div>';

    /* ── Select All bar ─────────────────── */
    var isAll=allSelected();
    html+='<div class="dh-cart-select-bar">';
    html+='<label class="dh-select-all-label">';
    html+='<input type="checkbox" class="dh-checkbox" '+(isAll?'checked':'')+' onchange="toggleSelectAll(this.checked)">';
    html+='<span class="dh-checkbox-custom"></span>';
    html+=' Select All ('+totalItems+' item'+(totalItems!==1?'s':'')+')</label>';
    if(selCount>0&&selCount<totalItems){
      html+='<span class="dh-select-info">'+selCount+' of '+totalItems+' selected</span>';
    }
    if(selCount>0){
      html+='<button class="dh-action-link dh-action-delete" onclick="removeSelected()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg> Delete selected</button>';
      html+='<button class="dh-action-link dh-action-save" onclick="saveSelectedForLater()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/></svg> Save for Later</button>';
    }
    html+='</div>';

    // Store groups
    html+='<div class="dh-cart-body"><div class="dh-cart-items">';
    storeKeys.forEach(function(src){
      var items=groups[src];
      html+='<div class="dh-cart-store-group" data-store="'+escHTML(src)+'">';
      var storeName=storeLabel(src);
      var storeIcon=src==='_subscription'?'\u26A1 ':'';
      html+='<div class="dh-cart-store-header"><span class="dh-cart-store-name">'+storeIcon+storeName+'</span> <span class="dh-cart-store-count">('+items.length+' item'+(items.length!==1?'s':'')+')</span></div>';
      items.forEach(function(item){
        html+=renderCartItem(item,src);
      });
      html+='<div class="dh-cart-store-shipping" id="dh-ship-'+escHTML(src)+'">'+
        '<span class="dh-ship-loading">Calculating shipping...</span>'+
      '</div>';
      html+='</div>';
    });
    html+='</div>';

    // Summary sidebar
    var selSubtotal=getSelectedSubtotal();
    html+='<div class="dh-cart-summary">'+
      '<h3>Order Summary</h3>'+
      '<div class="dh-cart-summary-row"><span>Selected items ('+selCount+')</span><span id="dh-selected-subtotal">'+formatMoney(selSubtotal)+'</span></div>'+
      '<div class="dh-cart-summary-row" id="dh-cart-shipping-total"><span>Shipping</span><span class="dh-ship-loading">Calculating...</span></div>'+
      '<div class="dh-cart-summary-row" id="dh-cart-tax-total" style="color:#718096;font-size:13px"><span>Estimated tax <span class="dh-tax-tip" onclick="this.classList.toggle(\'active\')"><span class="dh-tip-icon">i</span><span class="dh-tip-box">This is an estimate. The final tax amount will be calculated at checkout based on your delivery address.</span></span></span><span>'+formatMoney(Math.round(selSubtotal*0.07))+'</span></div>'+
      '<div class="dh-cart-summary-divider"></div>'+
      '<div class="dh-cart-summary-row dh-cart-total" id="dh-cart-total"><span>Estimated Total</span><span>'+formatMoney(selSubtotal)+'</span></div>'+
      '<div id="dh-cart-plus-upsell"></div>';
    if(selCount>0){
      html+='<a href="/checkout" class="dh-cart-checkout-btn">Proceed to Checkout ('+selCount+')</a>';
    } else {
      html+='<div class="dh-cart-checkout-disabled">Select items to checkout</div>';
    }
    html+='<a href="/" class="dh-cart-continue-link">\u2190 Continue Shopping</a>'+
    '</div>';

    html+='</div>'; // cart-body

    // Saved for Later section
    if(savedForLater.length>0){
      html+=renderSavedForLater();
    }

    container.innerHTML=html;
  }

  function renderCartItem(item,src){
    var img=item.image||item.featured_image?.url||'';
    var title=item.product_title||item.title||'';
    var variant=item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'';
    var price=item.price;
    var origPrice=item.original_price&&item.original_price>item.price?item.original_price:0;
    var qty=item.quantity;
    var key=item.key;
    var checked=selectedItems[key]?true:false;

    var html='<div class="dh-cart-item'+(checked?'':' dh-cart-item--dimmed')+'" data-key="'+escHTML(key)+'">';
    // Checkbox
    html+='<label class="dh-item-checkbox">';
    html+='<input type="checkbox" class="dh-checkbox" '+(checked?'checked':'')+' onchange="toggleItem(\''+escHTML(key)+'\',this.checked)">';
    html+='<span class="dh-checkbox-custom"></span>';
    html+='</label>';
    // Image
    html+='<div class="dh-cart-item-img"><img src="'+escHTML(img)+'" alt="'+escHTML(title)+'" loading="lazy"></div>';
    // Info
    html+='<div class="dh-cart-item-info">';
    html+='<div class="dh-cart-item-top">';
    html+='<div class="dh-cart-item-title">'+escHTML(title)+'</div>';
    // Delete button (trash icon)
    html+='<button class="dh-cart-item-delete" onclick="removeItem(\''+escHTML(key)+'\')" title="Delete">';
    html+='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';
    html+='</button>';
    html+='</div>';
    if(variant)html+='<div class="dh-cart-item-variant">'+escHTML(variant)+'</div>';
    html+='<div class="dh-cart-item-price">';
    html+='<span class="dh-cart-item-current">'+formatMoney(price)+'</span>';
    if(origPrice)html+=' <span class="dh-cart-item-orig">'+formatMoney(origPrice)+'</span>';
    html+='</div>';
    // Qty + actions row
    html+='<div class="dh-cart-item-actions">';
    html+='<div class="dh-cart-item-qty">';
    html+='<button class="dh-qty-btn" onclick="updateQty(\''+escHTML(key)+'\',-1)">\u2212</button>';
    html+='<span class="dh-qty-val">'+qty+'</span>';
    html+='<button class="dh-qty-btn" onclick="updateQty(\''+escHTML(key)+'\',1)">+</button>';
    html+='</div>';
    html+='<span class="dh-cart-item-divider">|</span>';
    html+='<button class="dh-cart-item-action" onclick="saveOneForLater(\''+escHTML(key)+'\')"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/></svg> Save for Later</button>';
    html+='<span class="dh-cart-item-divider">|</span>';
    html+='<button class="dh-cart-item-action dh-cart-item-action--delete" onclick="removeItem(\''+escHTML(key)+'\')"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg> Delete</button>';
    html+='</div>';
    html+='</div></div>';
    return html;
  }

  /* ── Saved for Later ─────────────────── */
  function renderSavedForLater(){
    if(!savedForLater||savedForLater.length===0)return '';
    var html='<div class="dh-saved-section">';
    html+='<div class="dh-saved-header"><h2>Saved for Later <span class="dh-saved-count">('+savedForLater.length+' item'+(savedForLater.length!==1?'s':'')+')</span></h2></div>';
    html+='<div class="dh-saved-grid">';
    savedForLater.forEach(function(item,idx){
      html+='<div class="dh-saved-item">';
      html+='<div class="dh-saved-item-img"><img src="'+escHTML(item.image||'')+'" alt="'+escHTML(item.title||'')+'" loading="lazy"></div>';
      html+='<div class="dh-saved-item-info">';
      html+='<div class="dh-saved-item-title">'+escHTML(item.title||'')+'</div>';
      if(item.variant&&item.variant!=='Default Title')html+='<div class="dh-saved-item-variant">'+escHTML(item.variant)+'</div>';
      html+='<div class="dh-saved-item-price">'+formatMoney(item.price||0)+'</div>';
      html+='<div class="dh-saved-item-actions">';
      html+='<button class="dh-saved-btn dh-saved-btn--cart" onclick="moveToCart('+idx+')">Move to Cart</button>';
      html+='<button class="dh-saved-btn dh-saved-btn--remove" onclick="removeSaved('+idx+')">Remove</button>';
      html+='</div>';
      html+='</div></div>';
    });
    html+='</div></div>';
    return html;
  }

  function updateShippingUI(){
    var totalShipping=0;
    var totalPlusSaves=0;
    var storeKeys=Object.keys(shippingByStore);

    storeKeys.forEach(function(src){
      var el=document.getElementById('dh-ship-'+src);
      if(!el)return;
      var d=shippingByStore[src];
      if(!d){
        el.innerHTML='<span style="color:#999">Shipping info unavailable</span>';
        return;
      }
      var ship=d.shipping||d;
      var cost=ship.cost||0;
      var isFree=ship.isFree||cost===0;
      var method=ship.method||'';
      var label=ship.label||'';
      var delivery=d.delivery||{};
      var shipIsPlus=ship.isPlus||false;
      totalShipping+=cost;
      if(!isPlus)totalPlusSaves+=(d.plusSaves||0);

      var html='<div class="dh-ship-row">';
      html+='<span class="dh-ship-icon">\uD83D\uDE9A</span> ';
      if(shipIsPlus){
        html+='<strong style="color:#6b46c1">FREE Shipping</strong> \u00B7 <span style="color:#6b46c1;font-weight:600">\u26A1 Plus</span>';
      } else if(ship.isDigital){
        html+='<strong style="color:#6b46c1">No shipping required</strong> \u00B7 <span style="color:#718096">Digital subscription</span>';
      } else {
        // Show delivery estimate without promising FREE (actual rate depends on cart total)
        if(method)html+='<span style="color:#4a5568;font-weight:500">'+escHTML(method)+'</span>';
        else html+='<span style="color:#4a5568;font-weight:500">Standard Shipping</span>';
      }
      var dLabel=delivery.formattedRange||delivery.label||'';
      if(dLabel)html+=' \u00B7 <span style="color:#2b6cb0">'+escHTML(dLabel)+'</span>';
      html+='</div>';

      if(!isPlus&&d.remaining&&d.remaining>0&&d.thresholdNote){
        html+='<div class="dh-ship-threshold">\uD83D\uDCA1 Add $'+d.remaining.toFixed(2)+' more from '+storeLabel(src)+' for FREE shipping</div>';
      }
      if(!isPlus&&cost>0){
        html+='<div class="dh-ship-plus">\u26A1 <strong style="color:#6b46c1">FREE</strong> with StyleHub Plus</div>';
      }
      el.innerHTML=html;
    });

    // Shipping total in summary
    var shipTotalEl=document.getElementById('dh-cart-shipping-total');
    if(shipTotalEl){
      // Match Shopify shipping zones: FREE >= $35, $5.99 below $35
      var selSubtotalDollars=getSelectedSubtotal()/100;
      var FREE_THRESHOLD=35;
      if(isPlus){
        shipTotalEl.innerHTML='<span>Shipping</span><span style="color:#6b46c1;font-weight:700">FREE \u26A1 Plus</span>';
        totalShipping=0;
      } else if(selSubtotalDollars>=FREE_THRESHOLD){
        shipTotalEl.innerHTML='<span>Shipping</span><span style="color:#38a169;font-weight:700">FREE</span>';
        totalShipping=0;
      } else {
        shipTotalEl.innerHTML='<span>Shipping</span><span>$5.99</span>';
        totalShipping=5.99;
      }
    }

    // Update total with shipping that matches Shopify checkout
    updateSummaryTotals(totalShipping);

    // Plus badge
    if(isPlus){
      var header=document.querySelector('.dh-cart-header h1');
      if(header&&!header.querySelector('.dh-plus-badge')){
        header.insertAdjacentHTML('beforeend',' <span class="dh-plus-badge" style="display:inline-block;background:linear-gradient(90deg,#6b46c1,#805ad5);color:#fff;font-size:12px;font-weight:700;padding:3px 10px;border-radius:20px;vertical-align:middle">\u26A1 PLUS</span>');
      }
    }

    // Plus upsell
    var plusEl=document.getElementById('dh-cart-plus-upsell');
    if(plusEl){
      if(!isPlus&&totalPlusSaves>0){
        plusEl.innerHTML='<div class="dh-cart-plus-banner">'+
          '<div class="dh-plus-title">\u26A1 Save $'+totalPlusSaves.toFixed(2)+' on shipping this order</div>'+
          '<div class="dh-plus-body">Try StyleHub Plus FREE for 7 days<br><span style="color:#999;font-size:12px">Then $7.99/mo \u00B7 Cancel anytime</span></div>'+
          '<a href="/pages/plus" class="dh-plus-cta">Start free trial \u2192</a>'+
        '</div>';
      } else if(isPlus){
        plusEl.innerHTML='<div class="dh-cart-plus-member" style="background:linear-gradient(135deg,#f5f3ff,#ede9fe);border:1px solid #c4b5fd;border-radius:12px;padding:16px;text-align:center;margin-top:16px">'+
          '<div style="font-size:15px;font-weight:700;color:#6b46c1">\u26A1 StyleHub Plus Member</div>'+
          '<div style="font-size:13px;color:#718096;margin-top:4px">FREE shipping on all orders \u00B7 60-day returns</div>'+
        '</div>';
      }
    }
  }

  function updateSummaryTotals(shippingDollars){
    var selSubtotal=getSelectedSubtotal();
    var selCount=getSelectedCount();
    var subEl=document.getElementById('dh-selected-subtotal');
    if(subEl)subEl.textContent=formatMoney(selSubtotal);
    // Estimated tax: 7% (FL state 6% + avg local 1%)
    var taxCents=Math.round(selSubtotal*0.07);
    var taxEl=document.getElementById('dh-cart-tax-total');
    if(taxEl)taxEl.innerHTML='<span>Estimated tax <span class="dh-tax-tip" onclick="this.classList.toggle(\'active\')"><span class="dh-tip-icon">i</span><span class="dh-tip-box">This is an estimate. The final tax amount will be calculated at checkout based on your delivery address.</span></span></span><span>'+formatMoney(taxCents)+'</span>';
    var totalEl=document.getElementById('dh-cart-total');
    if(totalEl){
      var shipCents=(shippingDollars||0)*100;
      totalEl.innerHTML='<span>Estimated Total</span><span>'+formatMoney(selSubtotal+shipCents+taxCents)+'</span>';
    }
  }

  /* ── Global functions ─────────────────── */
  window.toggleSelectAll=function(checked){
    if(!cartData||!cartData.items)return;
    cartData.items.forEach(function(item){
      selectedItems[item.key]=checked;
    });
    renderCart(cartData);
    // Re-run shipping UI since it was already fetched
    if(Object.keys(shippingByStore).length>0)updateShippingUI();
  };

  window.toggleItem=function(key,checked){
    selectedItems[key]=checked;
    renderCart(cartData);
    if(Object.keys(shippingByStore).length>0)updateShippingUI();
  };

  window.removeSelected=function(){
    if(!cartData||!cartData.items)return;
    var keysToRemove=cartData.items.filter(function(i){return selectedItems[i.key]}).map(function(i){return i.key});
    if(keysToRemove.length===0)return;
    // Build updates object
    var updates={};
    keysToRemove.forEach(function(k){updates[k]=0;});
    fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({updates:updates})
    }).then(function(r){return r.json()}).then(function(){
      keysToRemove.forEach(function(k){delete selectedItems[k]});
      init();
      updateHeaderCount();
    });
  };

  window.saveSelectedForLater=function(){
    if(!cartData||!cartData.items)return;
    var itemsToSave=cartData.items.filter(function(i){return selectedItems[i.key]});
    if(itemsToSave.length===0)return;
    // Save item data to localStorage
    itemsToSave.forEach(function(item){
      var exists=savedForLater.find(function(s){return s.variantId===item.variant_id});
      if(!exists){
        savedForLater.push({
          variantId:item.variant_id,
          productId:item.product_id,
          title:item.product_title||item.title,
          variant:item.variant_title,
          price:item.price,
          image:item.image||'',
          quantity:item.quantity,
          properties:item.properties||{}
        });
      }
    });
    localStorage.setItem('stylehub_saved_later',JSON.stringify(savedForLater));
    // Remove from cart
    var updates={};
    itemsToSave.forEach(function(i){updates[i.key]=0;});
    fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({updates:updates})
    }).then(function(r){return r.json()}).then(function(){
      itemsToSave.forEach(function(i){delete selectedItems[i.key]});
      init();
      updateHeaderCount();
    });
  };

  window.saveOneForLater=function(key){
    if(!cartData||!cartData.items)return;
    var item=cartData.items.find(function(i){return i.key===key});
    if(!item)return;
    var exists=savedForLater.find(function(s){return s.variantId===item.variant_id});
    if(!exists){
      savedForLater.push({
        variantId:item.variant_id,
        productId:item.product_id,
        title:item.product_title||item.title,
        variant:item.variant_title,
        price:item.price,
        image:item.image||'',
        quantity:item.quantity,
        properties:item.properties||{}
      });
      localStorage.setItem('stylehub_saved_later',JSON.stringify(savedForLater));
    }
    // Remove from cart
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:0})
    }).then(function(r){return r.json()}).then(function(){
      delete selectedItems[key];
      init();
      updateHeaderCount();
    });
  };

  window.moveToCart=function(idx){
    var item=savedForLater[idx];
    if(!item)return;
    var body={id:item.variantId,quantity:item.quantity||1};
    if(item.properties&&Object.keys(item.properties).length>0)body.properties=item.properties;
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){return r.json()}).then(function(){
      savedForLater.splice(idx,1);
      localStorage.setItem('stylehub_saved_later',JSON.stringify(savedForLater));
      init();
      updateHeaderCount();
    }).catch(function(err){
      console.error('Failed to move to cart:',err);
    });
  };

  window.removeSaved=function(idx){
    savedForLater.splice(idx,1);
    localStorage.setItem('stylehub_saved_later',JSON.stringify(savedForLater));
    // Re-render saved section
    var savedSection=document.querySelector('.dh-saved-section');
    if(savedSection){
      if(savedForLater.length===0){
        savedSection.remove();
      } else {
        savedSection.outerHTML=renderSavedForLater();
      }
    }
  };

  window.updateQty=function(key,delta){
    var items=cartData?.items||[];
    var item=items.find(function(i){return i.key===key});
    if(!item)return;
    var newQty=Math.max(0,item.quantity+delta);
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:newQty})
    }).then(function(r){return r.json()}).then(function(){init()});
  };

  window.removeItem=function(key){
    var row=document.querySelector('.dh-cart-item[data-key="'+key+'"]');
    if(row){
      row.style.transition='opacity 0.3s, transform 0.3s';
      row.style.opacity='0';
      row.style.transform='translateX(20px)';
    }
    setTimeout(function(){
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity:0})
      }).then(function(r){return r.json()}).then(function(){
        delete selectedItems[key];
        init();
        updateHeaderCount();
      });
    },300);
  };

  window.saveZip=function(){
    var field=document.getElementById('dh-cart-zip-field');
    if(!field)return;
    var v=field.value.trim();
    if(v&&/^\d{5}$/.test(v)){
      localStorage.setItem('stylehub_zip',v);
      zip=v;
      init();
    }
  };

  function updateHeaderCount(){
    var badge=document.getElementById('dh-cart-count');
    if(badge)fetch('/cart.js').then(function(r){return r.json()}).then(function(d){badge.textContent=d.item_count});
  }

  function formatMoney(cents){
    return '$'+(cents/100).toFixed(2);
  }

  function escHTML(s){var d=document.createElement('div');d.textContent=s||'';return d.innerHTML}

  function cartSkeleton(){
    return '<div style="max-width:1200px;margin:0 auto;padding:40px 20px">'+
      '<div style="height:32px;width:250px;background:#f0f0f0;border-radius:6px;margin-bottom:30px"></div>'+
      '<div style="display:flex;gap:30px;flex-wrap:wrap">'+
        '<div style="flex:1;min-width:300px">'+
          '<div style="height:120px;background:#f0f0f0;border-radius:8px;margin-bottom:16px"></div>'+
          '<div style="height:120px;background:#f0f0f0;border-radius:8px;margin-bottom:16px"></div>'+
        '</div>'+
        '<div style="width:340px">'+
          '<div style="height:280px;background:#f0f0f0;border-radius:8px"></div>'+
        '</div>'+
      '</div></div>';
  }
})();
